import { generatePath } from "@routes/utils";
import type { IExtractParams } from "@routes/types";

const pathBase = `/faculties/`;
const pathById = `${pathBase}:facultyId/`;
const academicGroupPath = `${pathById}academic-groups/`;
const imagePath = `${pathById}image/`;

export type IFacultyPathParams = IExtractParams<typeof pathById>;

export const faculties = {
  getAll: () => generatePath(pathBase, null),
  post: () => generatePath(pathBase, null),
  get: (param: IFacultyPathParams) => generatePath(pathById, param),
  put: (param: IFacultyPathParams) => generatePath(pathById, param),
  patch: (param: IFacultyPathParams) => generatePath(pathById, param),
  delete: (param: IFacultyPathParams) => generatePath(pathById, param),
  academicGroup: {
    getAll: (param: IFacultyPathParams) =>
      generatePath(academicGroupPath, param),
  },
  image: {
    post: (param: IFacultyPathParams) => generatePath(imagePath, param),
    delete: (param: IFacultyPathParams) => generatePath(imagePath, param),
  },
};
